import type { AppLocale } from './localeStorage'

export function intlLocale(locale: AppLocale): string {
  return locale === 'es' ? 'es-US' : 'en-US'
}

export function formatFieldDate(
  value: Date | string | number,
  locale: AppLocale,
  options?: Intl.DateTimeFormatOptions
): string {
  const d = value instanceof Date ? value : new Date(value)
  if (Number.isNaN(d.getTime())) return ''
  return new Intl.DateTimeFormat(intlLocale(locale), options ?? {
    month: 'numeric',
    day: 'numeric',
    year: 'numeric',
  }).format(d)
}

export function formatFieldDateTime(
  value: Date | string | number,
  locale: AppLocale
): string {
  return formatFieldDate(value, locale, {
    month: 'numeric',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  })
}

/** Always US dollar display, even when UI language is Spanish. */
export function formatUsd(amount: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(amount)
}
